import PlanTrip from "../components/home/Plantrip";
import Banner from "../components/home/Banner";
import ChooseUs from "../components/home/ChooseUs";
import Testimonials from "../components/home/Testimonials";
import Faq from "../components/home/Faq";
import Footer from "../components/Footer";
import CarSlide from "../components/home/CarSlide";
import BookCarSection from "../components/home/BookCarSection";
import Navbar2 from "../components/Navbar2";
import ScrollToTopButton from "../components/home/ScrollToTopButton";
import { useEffect } from "react";
import WhatsAppFloatingButton from "../components/home/WhatsAppFloatingButton";

function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Navbar2 />
      <BookCarSection />
      <PlanTrip />
      <CarSlide />
      <Banner />
      <ChooseUs />
      <Testimonials />
      <Faq />
      <ScrollToTopButton />
      <WhatsAppFloatingButton />
      <Footer />
    </>
  );
}

export default Home;
